import React from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';

function ReportTypeSelect({ reportType, onSelect }) {
  return (
    <div className="flex">
      <div className="text-muted m-r-16">Report Type</div>
      <ButtonToolbar style={{ width: '160px' }}>
        <DropdownButton
          bsStyle="info"
          title={`${reportType} Chart`}
          id="status-filter"
          className="btn-block text-capitalize"
          onSelect={(val) => onSelect({ reportType: val, isVisible: false })}
          pullRight
        >
          <MenuItem active={reportType === 'pie'} eventKey="pie">
            Pie Chart
          </MenuItem>
          <MenuItem active={reportType === 'gantt'} eventKey="gantt">
            Gantt Chart
          </MenuItem>
          <MenuItem active={reportType === 'bar'} eventKey="bar">
            Bar Chart
          </MenuItem>
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default ReportTypeSelect;
